import { type InternalAxiosRequestConfig } from 'axios';

import { keycloak } from '@abaninja/util-keycloak';

export const requestBearerTokenInterceptor = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
  const newConfig = { ...config };

  if (!keycloak?.token) {
    return config;
  }

  newConfig.headers.Authorization = `Bearer ${keycloak.token}`;

  return newConfig;
};
